import * as React from 'react';
import { Spinner } from '@fluentui/react-components';
import loadable from '@loadable/component';
import { Redirect, Route, Switch } from 'react-router-dom';
import { usePixelTracking } from '../../modules/telemetry/tags';

const Loading = <Spinner size="large" />;

const Signup = loadable(() => import(/* webpackChunkName: "signup" */ './Signup'), { fallback: Loading });
const Apply = loadable(() => import(/* webpackChunkName: "apply" */ './Apply'), {
  fallback: Loading,
});
const Submitted = loadable(() => import(/* webpackChunkName: "apply" */ './Submitted'), { fallback: Loading });

export default function ApplyFlow() {
  usePixelTracking();

  return (
    <Switch>
      <Route exact path="/signup">
        <Signup />
      </Route>
      <Route exact path="/apply">
        <Apply />
      </Route>
      <Route exact path="/apply/submitted">
        <Submitted />
      </Route>
      <Route>
        <Redirect to="/apply" />
      </Route>
    </Switch>
  );
}
